module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"header":"Itens","name":"Nome","description":"Descrição","quantity":"Quantidade","amount":"Valor unitário","totalAmount":"Valor total"},"en-US":{"header":"Items","name":"Name","description":"Description","quantity":"Quantity","amount":"Amount","totalAmount":"Total amount"}}')
  delete Component.options._Ctor
}
